import React from 'react';
import { Button } from 'react-bootstrap-5';

type SearchAreaProps = {
  searchArea: () => void;
}

export default function SearchThisArea({ searchArea }: SearchAreaProps) {
  return (
    <div className="bg-white rounded p-1"
      style={{
        position: 'absolute',
        bottom: '20px',
        right: '35%',
        zIndex: 1000,
      }}
    >
      <Button
        variant="outline-primary"
        onClick={searchArea}
      >
        Search This Area
      </Button>
    </div>
  );
}
